import axios from "axios";
import { DateTime } from "luxon";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./_viewWeek.scss";

import {
  setData,
  setDataEnd,
  setDataStart,
  setFasce,
  setKwhAvg,
  setKwhMax,
  setPriceKwhAvgWeek,
  setSpesaAvg,
  setSpesaMax,
} from "../../../features/dataWeekSlice";

import BarContainer from "./_barContainer";
import CircularProgress from "@mui/material/CircularProgress";
import BarIndex from "./_barIndex";
import WeekFilter from "./_filter";
import CardWeek from "./_cardsWeek";
import Fasce from "./_fasce";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ListWeek from "./_list";
import { ReactComponent as Euro } from "../../../assets/new-icons/euroIcon.svg";

function ViewWeek() {
  const dispatch = useDispatch();
  const [dateStart, setDateStart] = useState(
    DateTime.local().startOf("week").toISODate()
  );
  const [dateEnd, setDateEnd] = useState(
    DateTime.local().endOf("week").toISODate()
  );
  const [dateYear, setDateYear] = useState(
    DateTime.local().startOf("week").toFormat("y")
  );
  const [dateStartPrevious, setDateStartPrevious] = useState(
    DateTime.local().startOf("week").plus({ weeks: -1 }).toISODate()
  );
  const [dateEndPrevious, setDateEndPrevious] = useState(
    DateTime.local().startOf("week").plus({ weeks: -1 }).toISODate()
  );
  const [lastWeek, setLastWeek] = useState(
    DateTime.local().endOf("week").toISODate()
  );
  const [loading, setLoading] = useState(true);
  const podCode = useSelector((user) => user.user.info.pod_code);
  const token = useSelector((user) => user.user.info.token_value);
  const userToken = useSelector((user) => user.user.info.user_id);
  const data = useSelector((user) => user.dataWeek.data);
  const maxValueArray = data && data.map((r) => parseFloat(r.kwh_tot));
  const maxEuroArray = data && data.map((r) => parseFloat(r.spesa_giorno));
  const maxValue = maxValueArray && Math.max(...maxValueArray);
  const maxEuro = maxEuroArray && Math.max(...maxEuroArray)
  const maxEuroValue = maxEuroArray && Math.max(...maxEuroArray);
  const maxKwhValue = maxValueArray && Math.max(...maxValueArray)
  const [maxItems, setMaxItems] = useState(6);
  const getSumValue = maxValueArray && maxValueArray.reduce((a, b) => a + b, 0)
  const avarageKwh = maxValueArray && (getSumValue / maxValueArray.length) || 0
  const [switchEuro, setSwitchEuro] = useState(true)

  useEffect(() => {
    init();
  }, [dateStart, dateEnd]);


  const init = async () => {
    if (!podCode || !token || !userToken) {
      setLoading(true);
      return;
    } else {
      const dataApi = `https://my.revoluce.it/area_utente/gestione/api/deliveries/getDeliveryDayNew.php?codice_pod=${podCode}&token=${token}&userToken=${userToken}&debug=1&date_start=${dateStart}&date_end=${dateEnd}`;
      const { data: dataBig } = await axios.get(dataApi);
      const { data } = dataBig;
      let { consumptions } = data;
      if (
        consumptions.length > 0 &&
        consumptions[consumptions.length - 1].id !== null
        
      ) {
        const { consumptions, total_f1, total_f2, total_f3 } = data;

        const kwhAvg = dataBig.medie_giorno_ultimo_anno.kwh;
        const kwhMax = data.kwhMax;
        const spesaAvg = dataBig.medie_giorno_ultimo_anno.euro;
        const spesaMax = data.spesaMax;
        const priceAvgWeek = data.consumptionsAvgCosti;
       
        dispatch(setPriceKwhAvgWeek(priceAvgWeek));
        const getTotal = consumptions
          .map((r) => r.spesa_giorno)
          .reduce((a, b) => a + b, 0);
        if (getTotal !== 0) {
          setDataWeekSlice(
            consumptions,
            kwhAvg,
            kwhMax,
            spesaMax,
            spesaAvg,
            [total_f1, total_f2, total_f3],
            dateStart,
            dateEnd
          );
        }
        setLoading(false);
      } else {
        goBackWeek()
      }
    }
  };
  const setDataWeekSlice = (
    consumptions,
    kwhAvg,
    kwhMax,
    spesaMax,
    spesaAvg,
    fasce,
    dateStart,
    dateEnd
  ) => {
    dispatch(setData(consumptions.reverse()));
    dispatch(setKwhAvg(kwhAvg));
    dispatch(setKwhMax(kwhMax));
    dispatch(setSpesaMax(spesaMax));
    dispatch(setSpesaAvg(spesaAvg));
    dispatch(setFasce(fasce));
    dispatch(setDataStart(dateStart));
    dispatch(setDataEnd(dateEnd));
  };
  const goBackWeek = () => {
    setLoading(true);
    setDateStart(DateTime.fromISO(dateStart).startOf('week').plus({ weeks: -1 }).toFormat('y-MM-dd'))
    setDateEnd(DateTime.fromISO(dateEnd).endOf('week').plus({ week: -1 }).toFormat('y-MM-dd'))
    setMaxItems(6);
  };
  const goForwardWeek = () => {
    setLoading(true);
    setDateStart(DateTime.fromISO(dateStart).startOf('week').plus({ weeks: +1 }).toFormat('y-MM-dd'))
    setDateEnd(DateTime.fromISO(dateEnd).endOf('week').plus({ week: +1 }).toFormat('y-MM-dd'))
    setMaxItems(6);
  };
  const goBackMonth = () => {
    setLoading(true);
    setDateStart(DateTime.fromISO(dateStart).plus({ months: -1 }).toFormat('y-MM-dd'))
    setDateEnd(DateTime.fromISO(dateEnd).plus({ months: -1 }).toFormat('y-MM-dd'))
    setMaxItems(6);
  };
  const goForwardMonth = () => {
    setLoading(true);
    setDateStart(DateTime.fromISO(dateStart).plus({ months: +1 }).toFormat('y-MM-dd'))
    setDateEnd(DateTime.fromISO(dateEnd).plus({ months: +1 }).toFormat('y-MM-dd'))
    setMaxItems(6);
  };
  return (
    <div className="week">
      <div
        className="week_graph"
        style={
          loading ? { alignItems: "center", justifyContent: "center" } : null
        }
      >
        {loading ? (
          <div className="loader">
            <CircularProgress />
          </div>
        ) : (
          <>
            <div className="backgroundLine">
              <div className="line"></div>
              <div className="line"></div>
              <div className="line"></div>
            </div>
            <BarIndex maxEuroValue={maxEuroValue} switchEuro={switchEuro} maxKwhValue={maxKwhValue} />
            <div className="week_graph-wrapper">
              {data &&
                data.map(
                  (d, i) =>
                    d.id && (
                      <BarContainer key={i} data={d} switchEuro={switchEuro} maxEuro={maxEuro} maxValue={maxValue} avarageKwh={avarageKwh}/>
                    )
                )}
            </div>
          </>
        )}
      </div>
      <div className="week-filter_switch">
        <div className="week-filter_switch-right">
          <WeekFilter
            goForwardWeek={() => goForwardWeek()}
            goBackWeek={() => goBackWeek()}
            goBackMonth={() => goBackMonth()}
            goForwardMonth={() => goForwardMonth()}
            dateStart={dateStart}
            dateEnd={dateEnd}
            lastWeek={lastWeek}
          />
        </div>
        <div className="week-filter_switch-left">
          <div className="switch" onClick={() => setSwitchEuro(!switchEuro)}>
              <div className={`box ${switchEuro ? 'active' : null}`}>
                  <Euro />
              </div>
              <div className={`box ${!switchEuro ? 'active' : null}`}>
                  <p>kWh</p>
              </div>
          </div>
        </div>
      </div>
      <div className="week_cards">
        {data && data.map((d, i) => d.id && <CardWeek key={i} data={d} />)}
      </div>
      <Fasce maxEuroArray={maxEuroArray} />
      <ListWeek
        maxItems={maxItems}
        setMaxItems={setMaxItems}
        data={data}
        goForwardWeek={() => goForwardWeek()}
        goBackWeek={() => goBackWeek()}
        goBackMonth={() => goBackMonth()}
        goForwardMonth={() => goForwardMonth()}
        dateStart={dateStart}
        dateEnd={dateEnd}
        lastWeek={lastWeek}
        avarageKwh={avarageKwh}
      />
    </div>
  );
}

export default ViewWeek;
